var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "#10B981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4 16.4C22.0818 16.4 21.7766 16.2736 21.5515 16.0485C21.3265 15.8235 21.2 15.5183 21.2 15.2C21.2 14.8817 21.3265 14.5765 21.5515 14.3515C21.7766 14.1264 22.0818 14 22.4 14H28.4C28.7183 14 29.0235 14.1264 29.2486 14.3515C29.4736 14.5765 29.6 14.8817 29.6 15.2V21.2C29.6 21.5183 29.4736 21.8235 29.2486 22.0485C29.0235 22.2736 28.7183 22.4 28.4 22.4C28.0818 22.4 27.7766 22.2736 27.5515 22.0485C27.3265 21.8235 27.2001 21.5183 27.2001 21.2V18.0968L22.0484 23.2484C21.8234 23.4734 21.5182 23.5997 21.2 23.5997C20.8819 23.5997 20.5767 23.4734 20.3517 23.2484L17.6 20.4968L12.4484 25.6484C12.2221 25.867 11.919 25.9879 11.6044 25.9852C11.2897 25.9825 10.9888 25.8563 10.7663 25.6338C10.5438 25.4113 10.4176 25.1103 10.4148 24.7957C10.4121 24.481 10.5331 24.1779 10.7516 23.9516L16.7516 17.9516C16.9767 17.7266 17.2819 17.6003 17.6 17.6003C17.9182 17.6003 18.2234 17.7266 18.4484 17.9516L21.2 20.7032L25.5033 16.4H22.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletTrendingUp);
export default __webpack_public_path__ + "static/media/wallet-trending-up.32f7432f6c799f632054127ad2ec3eb2.svg";
export { ForwardRef as ReactComponent };